// Which user someone is viewing the dashboard as, if any: `{ userId, email, canWrite }`. Kept in
// sessionStorage so it belongs to one tab and ends with it, and read by the API client
// (lib/api/client.js), which sends the id as X-Impersonate-User on every request. The backend then
// judges each request by that user's rights and refuses anything but reads, so viewing as someone
// can show what they see but never act for them. No transport here: the API client imports this
// module.

const KEY = "view-as-user";
// The client picked while viewing as someone, kept per tab beside the view (see
// lib/activeClientStorage.js) and dropped with it.
export const VIEW_AS_ACTIVE_CLIENT_KEY = "view-as-active-client";

export function viewingAs() {
  try {
    const viewing = JSON.parse(sessionStorage.getItem(KEY) ?? "null");
    return viewing?.userId ? viewing : null;
  } catch {
    return null;
  }
}

export const viewingAsUserId = () => viewingAs()?.userId ?? null;

export function setViewingAs({ userId, email, canWrite = false }) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ userId, email, canWrite }));
  } catch {
    /* storage unavailable: the view simply does not start */
  }
}

export function clearViewingAs() {
  try {
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem(VIEW_AS_ACTIVE_CLIENT_KEY);
  } catch {
    /* nothing stored */
  }
}
